module.exports = __webpack_public_path__ + "img/TESL-book-reading.09dc56a1.jpg";